module.exports = __webpack_public_path__ + "img/pem.1cbcef02.png";